import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button, Dropdown} from "semantic-ui-react";
import "./Style.css";
import {connect} from "react-redux";
import Lbl from "../../../../../components/Label/Lbl";
import cloneDeep from 'lodash/cloneDeep';
import * as actionTypes from '../../../../../store/Action/actionTypes';
import * as actionCreator from "../../../../../store/Action";
import apiConfig from "../../../../../axios/axios_api_services";
import axios_eventtag from "../../../../../axios/axios_eventtag";
import Cookies from "js-cookie";
import *  as DropDownConst from "../../../../../store/Reducer/DropDownConst"
import * as common from "../../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import {Card, Pagination} from 'antd';
import Download from "../../../../../components/Button/DownloadbleButton/index";
import * as timeutils from "../../../../../util/TimeConvertor";

class App extends React.Component{

  state = {

    etNotValid: false,

    eventHasSubEvents: false,
    eventSubEvents: [],
    subEventId:'',
    participantType: "PENDING",
    eventType: "",
    subEventParticipant: null,
    approvedParticipant: [],
    rejectedParticipants: [],

    //Pagination Handler
    currentPage: 0,
    totalPage: 0,
    totalEle: 0,
    maxPageViewCount: 3,
    startIndex: 1
  };

   // ------------------------- [function - use for get the sub events on a selected event ] -------------------------------

  getSubevents = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    if(this.props.selectPartObj.privacy !== "PUBLIC"){
      this.setState({
        participantType:"APPROVED",  eventType : this.props.selectPartObj.privacy
      })
    }
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    let id = this.props.selectPartObj.event_id;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id:id,corporateId: corporateId}),{headers:headers})
      .then(response => {
        if(response.data.success){
          let firstSubeventId = response.data.subEventList.length !== 0 ? response.data.subEventList[0].sub_event_id:'';
          this.setState({
            eventSubEvents: response.data.subEventList,
            subEventId:  firstSubeventId,

          });
          this.getAllParticipantsUsingStatusOrSubEventId("SUBEVENT_ID",firstSubeventId);
        }else {
          this.setState({
            eventSubEvents: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubevents();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.getSubevents();
  }

  // ------------------------- [function - use for changes in subevent select dropdown ] -------------------------------

  onChangeSubEventHandler = (e, {value}) => {
    this.setState({
      subEventId: value,
      currentPage: 0,
      totalEle: 0,
    });

    // #$#$

    this.state.eventSubEvents.map((result, i)=>{
      if(result.sub_event_id === value) {
          let x = new Date()>new Date(timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(result.end_time));
        this.setState({
          etNotValid: x
        });
      }
    });

    this.getAllParticipantsUsingStatusOrSubEventId("SUBEVENT_ID", value, this.state.currentPage);
  };

  // ------------------------- [function - use for changes in approve/pending dropdown ] -------------------------------

  onChangeApprovePendingHandler = (event, {value}) => {
    this.setState({
      participantType : value,
      currentPage: 0,
      totalEle: 0,
    });
    this.getAllParticipantsUsingStatusOrSubEventId("PARTICIPANT_STATUS",value, 0);
  };

  getAllParticipantsUsingStatusOrSubEventId = (type,value, pageId) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let participantStatus = type === "PARTICIPANT_STATUS" ? value:  this.state.participantType;
    let subEventId = type === "SUBEVENT_ID" ? value : this.state.subEventId;

    if(subEventId !== ""){
      this.props.spinnerHandler(true);
      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      axios_eventtag.get(apiConfig.VIEW_PARTICIPANTS_ON_STATUS({sub_event_id:subEventId, status:participantStatus, corporateId:corporateId, page: pageId, size: 5}), {headers:headers})
      .then(response => {

        if(response.data.success){
          if(participantStatus === "PENDING"){
            this.setState({
              subEventParticipant: response.data.body.content,
              currentPage: response.data.body.number,
              totalPage: response.data.body.totalPages,
              totalEle: response.data.body.totalElements,
            });
          }
          if(participantStatus === "APPROVED"){
            this.setState({
              approvedParticipant: response.data.body.content,
              currentPage: response.data.body.number,
              totalPage: response.data.body.totalPages,
              totalEle: response.data.body.totalElements,
            });
          }else{
            this.setState({
              rejectedParticipants: response.data.body.content,
              currentPage: response.data.body.number,
              totalPage: response.data.body.totalPages,
              totalEle: response.data.body.totalElements,
            });
            // this.props.spinnerHandler(true);
          }
        }else {
          this.setState({
            subEventParticipant:[],
            approvedParticipant:[],
            rejectedParticipants:[]
          });
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllParticipantsUsingStatusOrSubEventId(type,value,pageId);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
    }
    this.state.eventSubEvents.map((result, i)=>{
      if(result.sub_event_id === value) {
        let x = new Date()>new Date(timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(result.end_time));
        this.setState({
          etNotValid: x
        });
      }
    });
  };

  onClickApproveRejectHandler = (value,type) => {
    let participantId = value.participant_id;
    let status = value.participantRequestStatus !== "APPROVED" ? "APPROVED" : "REJECTED";
    if(type){
      status = type;
    }

    swal({
      title: "Are you sure you want to continue??",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":

          this.props.spinnerHandler(true);

          let corporateId = this.props.usr_obj.corporates[0].corporateId;

          const headers = {
            "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
          };

          axios_eventtag.patch(apiConfig.APPROVE_REJECT_PARTICIPANTS({participant_id:participantId, status:status, corporateId: corporateId}),{},{headers:headers})
          .then(response => {

            common.notifyMessage(response.data.success ? "\""+status+" \" Sucessfull":response.data.message, response.data.success ? 2:0);
            if(response.data.success){
              this.getAllParticipantsUsingStatusOrSubEventId();
            }
          })
          .catch(async error => {
              let result = await common.checkErrorResponse(error);
              if (result === 1) {
                this. onClickApproveRejectHandler(value,type);
              };
            })
          .finally(fin => {
            this.props.spinnerHandler(false);
          });
          break;
        default:
          break;
      }
    })


  };

  pointPage = ( pageId ) => {
    console.log("pageId: ", pageId);
    this.setState({
      currentPage: pageId - 1
    })
    this.getAllParticipantsUsingStatusOrSubEventId("SUBEVENT_ID", this.state.subEventId, pageId - 1);
  };

  render() {
    let subEventList = [];

    if(this.state.eventSubEvents.length !== 0){
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
            text: value.name,
            value:value.sub_event_id,
            key: value.sub_event_id
          })
      });
    }

    let columns = this.props.table_data.columns
    let registerdRows = [];
    let approvedRows = [];
    let rejectedRows =[];

    if(this.state.approvedParticipant !== null) {
      this.state.approvedParticipant.map((value, index) => {
        approvedRows.push({
          FirstName: value.userDTO.firstName,
          LastName:value.userDTO.lastName,
          Phone:value.userDTO.mobile,
          Email:value.userDTO.email,
          Action: <div>
            <Button disabled={this.state.etNotValid} style={{backgroundColor: '#ec2f2f',color: "white"}} onClick={(event)=>this.onClickApproveRejectHandler(value,"REJECTED")}>Reject</Button></div>
        })
      });
    }

    if(this.state.rejectedParticipants !== null) {
      this.state.rejectedParticipants.map((value, index) => {
        rejectedRows.push({
          FirstName: value.userDTO.firstName,
          LastName: value.userDTO.lastName,
          Phone: value.userDTO.mobile,
          Email: value.userDTO.email,
          Action: <div><Button disabled={this.state.etNotValid} style={{ backgroundColor: '#53bd52', color: "white" }} onClick={() => this.onClickApproveRejectHandler(value,"APPROVED")}>Approve</Button>
          </div>
        })
      })
    }


    if (this.state.subEventParticipant !== null){
      this.state.subEventParticipant.map((value, index) =>{
        registerdRows.push({
          FirstName: value.userDTO.firstName,
          LastName:value.userDTO.lastName,
          Phone:value.userDTO.mobile,
          Email:value.userDTO.email,
          Action: <div><Button disabled={this.state.etNotValid} style={{backgroundColor: '#53bd52',color: "white"}} onClick={()=>this.onClickApproveRejectHandler(value,"APPROVED")}>Approve</Button>
               <Button disabled={this.state.etNotValid} style={{backgroundColor: '#ec2f2f',color: "white"}} onClick={()=>this.onClickApproveRejectHandler(value,"REJECTED")}>Reject</Button></div>
        })
      })
    }

    return(
      <div>
        <MDBModal isOpen={true} toggle={()=>{}} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Participants of event
          {/* <Download data={this.state.participantType === "PENDING" ? registerdRows:this.state.participantType==="APPROVE"? approvedRows:rejectedRows} /> */}
          </MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={12}>
                    <Row>
                    <Col lg={4}>
                        <Lbl required>Sub Event</Lbl>
                        <Dropdown
                          fluid
                          selection
                          options={subEventList}
                          value= {this.state.subEventId}
                          onChange={this.onChangeSubEventHandler}
                        />
                      </Col>
                       <Col lg={4}>
                       <Lbl required>Approved/Reject/Pending</Lbl>
                       <Dropdown
                         fluid
                         selection
                         options={this.props.selectPartObj.privacy === "PUBLIC" ?DropDownConst.participantStatus:DropDownConst.private_participantStatus}
                         value={this.state.participantType}
                         onChange={this.onChangeApprovePendingHandler}
                       />
                     </Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                     <MDBDataTable
                        striped
                        searching={true}
                        displayEntries={false}
                        paging={false}
                        entries={8}
                        responsive
                        responsiveSm
                        responsiveMd
                        responsiveLg
                        responsiveXl
                        bordered
                        hover
                        // columns={}
                        // data = {{rows:this.state.participantType === "PENDING" ? registerdRows : this.state.participantType === "APPROVE" ? approvedRows:rejectedRows}}
                        data = {{rows:this.state.participantType === "APPROVED" ? approvedRows : this.state.participantType === "REJECTED" ? rejectedRows:registerdRows , columns:columns}}
                     />
                    <Pagination style={{justifyContent: 'center',alignItems: 'center',display:'flex'}} pageSize={5} defaultCurrent={this.state.currentPage + 1} total={this.state.totalEle} onChange={this.pointPage} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  table_data: state.participantReducer.Event_Participant_Table_data2,
  usr_obj: state.userReducer.user
});

const mapDispatchToProps = (dispatch) => {
  return {
//     // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
//     //user data handler:
//     userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(App);
